import { CheckpointIProps } from '../types/types'

export const getPlacedCheckpoints = (
  checkpoints: CheckpointIProps[],
  filter: string,
  floorId: string
) => {
  return checkpoints
    ?.filter(
      (d) =>
        d?.name?.toLocaleLowerCase()?.includes(filter.toLocaleLowerCase()) ||
        filter === ''
    )
    .filter((d) => d.isPlaced && d?.floor?.id === floorId)
}

export const getUnPlacedCheckpoints = (
  checkpoints: CheckpointIProps[],
  filter: string
) => {
  return checkpoints
    ?.filter(
      (d) =>
        d?.name?.toLocaleLowerCase()?.includes(filter.toLocaleLowerCase()) ||
        filter === ''
    )
    .filter((d) => !d.isPlaced)
    ?.sort(
      (a, b) =>
        new Date(b?.createdAt).valueOf() - new Date(a?.createdAt).valueOf()
    )
}
